module.exports = __webpack_public_path__ + "assets/vegan-5130e5.svg";